export default "__VITE_ASSET__DcT$0B3k__"